import { Component} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AccountComponent } from "@pages/users/user-profile/user-profile/account/account.component";

@Component({
  selector: 'app-user-profile',
    imports: [TranslateModule, AccountComponent],
  templateUrl: './user-profile.component.html',
  standalone: true,
  styleUrl: './user-profile.component.scss'
})
export class UserProfileComponent {

}
